import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

CONFIG.introPages[0] = {
  key: 'what-is-it',
  title: 'What is the Dream it Real Scholarship?',
  layout: 'welcome',
  body: `
The Dream it Real Program is meant to help break cycles of inequality by empowering 
the next generation to reach their full potential through higher education. These 
funds do not require repayment.

Please submit an application through {PROGRAM_NAME} to access your Scholarship. 
To learn more, go to {FAQ_PAGE}.`,
};

CONFIG.overrides = {
  statuses: [
    {
      status: 'Application',
      label: 'Apply for the Dream it Real Scholarship',
      message:
        'These funds do not require repayment and are for fellows within the Dream it Real Program through The Opportunity Network.',
    },
  ],
};
const youAndYourSituationSection = CONFIG.sections.find(({ key }) => key === 'youAndYourSituation');
const youAndYourSituationSectionQuestionGroup = youAndYourSituationSection.questionGroups.find(
  ({ key }) => key === 'youAndYourSituation',
);
youAndYourSituationSectionQuestionGroup.questions =
  youAndYourSituationSectionQuestionGroup.questions.filter(
    (question) => question.key !== 'requestedAmount',
  );
youAndYourSituationSectionQuestionGroup.questions = [
  CONFIG.definitions.questions.believesFundsWouldHelp,
  ...youAndYourSituationSectionQuestionGroup.questions,
];

youAndYourSituationSection.overview.description =
  'In this section you’ll select a response to several statements regarding your financial situation.';

CONFIG.sections = CONFIG.sections.filter(({ key }) => key !== 'documents');

export default CONFIG;
